import {
  fx_createAplicacionRequest,
  fx_createAplicacionRequestEmpty,
} from "../../../../modulos/aplicaciones/request/AplicacionRequest";
import { AplicacionResponse } from "../../../../modulos/aplicaciones/response/AplicacionResponse";
import { fx_createAplicacionGetYearGroupListByFincaIdService } from "../../../../modulos/aplicaciones/services/AplicacionGetYearGroupListService";
import { IGetListYearGroupService } from "../../../../abstractions/services/actions/IGetListYearGroupService";
import { AplicacionDeleteGrpcService } from "../../../../modulos/aplicaciones/services/AplicacionDeleteGrpcService";
import { serviceProvider } from "../../../../comun/provider/ServiceProvider";
import { formatFechaCorta } from "../../../../utils/fechaUtils";
import { BaseSecondSidebarItemRender } from "../../../base/sidebar/BaseSecondSidebarItemRender";
import { BaseSecondSidebarRender } from "../../../base/sidebar/BaseSecondSidebarRender";
import { ConfirmModalRender } from "../../../implementations/modal/ConfirmModalRender";
import { AplicacionFormModalRender } from "../modal/AplicacionFormModalRender";
import { AplicacionSidebarItemRender } from "../list/AplicacionSidebarItemRender";

/** Segundo sidebar del módulo de aplicaciones: aplicaciones de la finca activa
 *  agrupadas por año; al seleccionar un item notifica la aplicación (el mapa
 *  pinta dónde se aplicó: la trayectoria si fue por dron, los lotes aplicados
 *  si fue manual). El alta (+) llega con el formulario del módulo.
 *
 *  Una finca puede tener **varias aplicaciones el mismo día**, así que el item
 *  rotula fecha + método: con la fecha sola serían filas idénticas. */
export class AplicacionesSecondSidebarRender extends BaseSecondSidebarRender<AplicacionResponse> {
  /**
   * @param onBack                Acción del botón volver.
   * @param _onAplicacionSelected Notifica la aplicación seleccionada.
   */
  constructor(
    onBack: () => void,
    private readonly _onAplicacionSelected: (
      aplicacion: AplicacionResponse,
    ) => void,
  ) {
    super(onBack);
  }

  protected get title(): string {
    return "APLICACIONES";
  }

  /** Aplicaciones de la finca activa agrupadas por año. */
  protected getYearGroupListService(): IGetListYearGroupService<AplicacionResponse> {
    const finca = serviceProvider.getFincaSelectedService().getRequired();
    return fx_createAplicacionGetYearGroupListByFincaIdService(finca.id);
  }

  /** Item de aplicación (fecha + detalle expandible + editar/eliminar). */
  protected createItem(item: AplicacionResponse): BaseSecondSidebarItemRender {
    return new AplicacionSidebarItemRender(
      item,
      this._onAplicacionSelected,
      (aplicacion) =>
        new AplicacionFormModalRender(
          fx_createAplicacionRequest(aplicacion),
        ).init(),
      (aplicacion) => this._confirmDelete(aplicacion),
    );
  }

  /** Confirma y elimina la aplicación; al éxito recarga la página. */
  private _confirmDelete(aplicacion: AplicacionResponse): void {
    const finca = serviceProvider.getFincaSelectedService().getRequired();
    new ConfirmModalRender({
      title: "Eliminar aplicación",
      message: `¿Está seguro que desea eliminar la aplicación del <strong>${formatFechaCorta(aplicacion.fechaAplicacion)}</strong> de <strong>${finca.nombreFinca}</strong>? Esta acción no se puede deshacer.`,
      onConfirm: async () => {
        await new AplicacionDeleteGrpcService().deleteAsync(aplicacion);
        serviceProvider.getLayoutService().reload();
      },
    }).init();
  }

  /** Botón +: abre el formulario de nueva aplicación de la finca activa. */
  protected onAdd(): void {
    const finca = serviceProvider.getFincaSelectedService().getRequired();
    new AplicacionFormModalRender(
      fx_createAplicacionRequestEmpty(finca.id),
    ).init();
  }
}
